import { render } from "./TableNotice.vue?vue&type=template&id=23333507&scoped=true"
import script from "./TableNotice.vue?vue&type=script&lang=js"
export * from "./TableNotice.vue?vue&type=script&lang=js"

import "./TableNotice.vue?vue&type=style&index=0&id=23333507&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23333507"]])

export default __exports__